import styled from 'styled-components';

const FieldDatePickerView = styled.div`
  display: flex;
  margin-bottom: 0.5em;
  box-shadow: 0 0.25em 0.625em rgba(53,118,172,0.15);
  position: relative;
  > [class^="FieldView"] {
    flex: 1;
    margin-bottom: 0!important;
    box-shadow: none!important;
    &:nth-of-type(2) {
      border-left: 1px solid var(--gray300);
    }
  }
`;

export default FieldDatePickerView;
